/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { AiOutlineQrcode } from 'react-icons/ai';
import { FiCamera } from 'react-icons/fi';
import { ImQrcode } from 'react-icons/im';
import { FaCheckCircle } from 'react-icons/fa';
import { PageContext } from '../context';
import { LPTitle, LPText } from '../../styles';
import {
  UserInfoWrapper,
  UserInfoHeader,
  UserInfoBody,
} from './styles';

import StickyFooter from '../../../components/StickyFooter';

const CheckInConfirm = () => {
  const { goToIndex } = useContext(PageContext);

  return (
    <>
      <UserInfoWrapper>
        <UserInfoHeader>
          <FaCheckCircle className="hugeIcon" />
        </UserInfoHeader>
        <UserInfoBody>
          <LPTitle upcase center>
            <span className="thin">
              Check-in
            </span>
            Completed
          </LPTitle>
          <ImQrcode className="hugeIcon" />
          <LPText>
            To check-in next guests, please use
            <FiCamera />
            <b> camera </b>
            to scan
            <AiOutlineQrcode />
            <b> QR code </b>
          </LPText>
        </UserInfoBody>
      </UserInfoWrapper>

      <StickyFooter title="Done" handleOnclick={goToIndex} />
    </>
  );
};

CheckInConfirm.propTypes = {};

export default CheckInConfirm;
